import { memo } from 'react'

import Section2 from './Section2'

const Section2Component = memo(Section2)

export default Section2Component
